import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const invoiceId = (invoice) => invoice?.id || invoice?._id;

const AddOrderChargesModal = ({
  open,
  onClose,
  invoices = [],
  onCreateInvoice,
  onAppendToInvoice,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const eligibleInvoices = useMemo(
    () =>
      invoices.filter(
        (invoice) =>
          invoice?.status === "draft" &&
          !invoice?.settledLock &&
          invoiceId(invoice)
      ),
    [invoices]
  );
  const [destination, setDestination] = useState("new");

  useEffect(() => {
    if (open) setDestination("new");
  }, [open]);

  const continueToCharges = () => {
    if (destination === "new") {
      onCreateInvoice();
      return;
    }
    onAppendToInvoice(destination);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Add order charges</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Add charges to a draft invoice or create a separate invoice for this
          order.
        </Typography>
        {eligibleInvoices.length === 0 && (
          <Alert severity="info" sx={{ mb: 2 }}>
            This order has no editable draft invoices. A new invoice will be
            created so issued and settled invoices remain unchanged.
          </Alert>
        )}
        <RadioGroup
          value={destination}
          onChange={(event) => setDestination(event.target.value)}
        >
          <FormControlLabel
            value="new"
            control={<Radio />}
            label="Create a new invoice"
          />
          {eligibleInvoices.map((invoice) => (
            <FormControlLabel
              key={invoiceId(invoice)}
              value={invoiceId(invoice)}
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body2">
                    Add to {invoiceId(invoice)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Current total: R
                    {Number(invoice.total || 0).toLocaleString("en-ZA", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </Box>
              }
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={continueToCharges}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddOrderChargesModal;
